/**
 * Created by slava on 23.03.17.
 */

const EditorScene = cc.Scene.extend({
    ctor: function (options) {
        this._super();

        options = options || {};
        options.level = options.level || new Level(cleverapps.meta.selectedLocationId(), 0);

        this.options = options;

        this.sceneComponent = ComponentMap.attach(this, new SceneComponent({
            sceneName: cleverapps.Environment.SCENE_EDITOR
        }));

        this.gameSceneComponent = new GameSceneComponent({ args: [{ level: options.level, gameOptions: options.gameOptions }] });

        this.sceneComponent.setStyling(this.getBackgroundStyles());
        this.sceneComponent.setAudioStyles(this.gameSceneComponent.audioStyles);
        this.sceneComponent.setBundles(this.listBundles());
    },

    onSceneLoaded: function () {
        const level = this.gameSceneComponent.level;

        connector.ads.closeStickyCallback();
        cleverapps.resolution.setContainerPadding();

        cleverapps.environment.setLevel(level.levelNo);
        cleverapps.environment.setEpisode(level.episodeNo);

        if (cleverapps.config.editorMode) {
            cleverapps.environment.setScene(cleverapps.Environment.SCENE_EDITOR);
        }

        LevelManager.getInstance().updateLoadedLevel(level);

        this.game = new Game(level);

        this.editor = new Editor();

        const editorView = new EditorView(this.editor);
        this.addChild(editorView);

        if (typeof EditorController !== "undefined") {
            new EditorController(this.editor, this, editorView);
        }

        this.editor.load();

        const orangery = Editor.currentEditor.orangery;
        if (orangery) {
            const control = new cc.Node();
            control.addChild(new OrangeryView(orangery));
            this.addChild(control);

            ComponentMap.attach(control, new HidingComponent({
                direction: cleverapps.UI.VERTICAL,
                control: orangery.getControlName()
            }));
        }

        ComponentUtils.findComponentByName(this, "UpMenuController").getControlButtons().forEach((button) => {
            button.passBlocked = true;
        });
    },

    onCloseAction: function () {
        cleverapps.setUrlHash({ mode: undefined });

        if (cleverapps.config.adminMode) {
            cleverapps.config.editorMode = false;
            AdministratorScene.open();
            return true;
        }
    },

    initPool: function () {
    },

    saveCellSkin: function () {
        Game.currentGame.level.content.cellSkins = this.editor.cellSkins;
    },

    getBackgroundStyles: function () {
        if (cleverapps.config.type === "merge") {
            return cleverapps.skins.getSlot("gameSceneBg") || cleverapps.styles.Map2dLocationScene.backgroundStyles;
        }

        return this.gameSceneComponent.getBackgroundStyles();
    },

    onTransitionAnimationDidStart: function () {
        return true;
    },

    listBundles: function () {
        let base;

        if (typeof HomefixSceneComponent !== "undefined") {
            base = this.gameSceneComponent.level ? HomefixSceneComponent.prototype.listBundles.call(this) : [];
        } else {
            base = this.gameSceneComponent.level ? this.gameSceneComponent.bundles : [];
        }

        const all = Editor.BUNDLES.filter((bundle) => bundles[bundle]);

        return cleverapps.unique(base.concat(all).concat(["editor"]));
    },

    destructor: function () {
        this.editor.destructor();

        this.game.stop();
        Game.currentGame = undefined;
    }
});

EditorScene.open = function (options, callback) {
    options = options || {};

    if (!options.level) {
        LevelManager.getInstance().setLevel({ episodeNo: options.episodeNo, levelNo: options.levelNo });
        options.level = LevelManager.getInstance().level;
    }

    cleverapps.setUrlHash({ mode: "editor" });

    cleverapps.config.editorMode = true;
    cleverapps.config.adminMode = true;

    cleverapps.meta.switchLocation(Administrator.guessLocation(options.level));

    if (callback) {
        cleverapps.scenes.replaceScene(new EditorScene(options), callback);
    } else {
        cleverapps.focusManager.display({
            focus: "EditorSceneOpen",
            action: function (f) {
                cleverapps.scenes.replaceScene(new EditorScene(options), f);
            }
        });
    }
};
